// extracted by mini-css-extract-plugin
export var icon = "LockedLink-module--icon--kyc7Z";
export var locked = "LockedLink-module--locked--Es2XA";
export var title = "LockedLink-module--title--U+Y+w";
export var tooltip = "LockedLink-module--tooltip--MSBOU";